import { render, staticRenderFns } from "./RelacaoModulosCliente.vue?vue&type=template&id=50e7d728&scoped=true&"
import script from "./RelacaoModulosCliente.vue?vue&type=script&lang=js&"
export * from "./RelacaoModulosCliente.vue?vue&type=script&lang=js&"
import style0 from "./RelacaoModulosCliente.vue?vue&type=style&index=0&id=50e7d728&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e7d728",
  null
  
)

export default component.exports